//ADD USER TRAINING
export const ADD_USER_TRAINING_REQUEST = "ADD_USER_TRAINING_REQUEST";
export const ADD_USER_TRAINING_SUCCESS = "ADD_USER_TRAINING_SUCCESS";
export const ADD_USER_TRAINING_FAIL = "ADD_USER_TRAINING_FAIL";
